<template>
    <div style="position: relative">
        <title-and-edit currentViewTitle="Ikke møtt- gebyrer" layout="portal"/>
        <div class="profile__container--content__orderhistory primary-font pt-5">
            <div v-if="appointments.length">
                <div v-for="appointment in appointments" :key="appointment.appointmentId">
                    <no-show-list-item @showDetails="appointment => switchComponent(appointment)" :noShowAppointment="appointment"></no-show-list-item>
                </div>
            </div>
            <div v-else>
                <v-overlay :value="loading" color="white" absolute style="height: 600px">
                    <v-progress-circular
                        color="var(--v-primary-base)"
                        indeterminate
                        size="64"
                    ></v-progress-circular>
                </v-overlay>
            </div>
        </div>
    </div>
</template>

<script>
import NoShowListItem from './components/NoShowListItem.vue'
import { NoContent, TitleAndEdit } from '../../../Common/CommonComponents'
export default {
    components: { NoShowListItem, NoContent, TitleAndEdit },
    data: () => ({
        loading: false,
    }),
    prop: {
        user: {}
    },
    methods: {
        switchComponent(appointment) {
            this.$router.push({name: 'Ikke møtt detaljer', params: {id: appointment.base64AppointmentId, siteId: appointment.siteId, order: appointment}})
        },
    },
    computed: {
        appointments() {
            return this.$store.getters['fairpay/getFairPayAppointments']
        }
    },
    async created() {
        await this.$store.dispatch('fairpay/getFairPayAppointmentDetails')
    }

}
</script>